import { ResolveFn } from '@angular/router';
import { StatesService } from '../commonServices/states.service';
import { inject } from '@angular/core';

export const statesResolver: ResolveFn<any> = (route, state) => {
  return inject(StatesService).get();
};
